import axios from 'axios'

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    // baseURL: 'http://localhost:3000',
    headers: {
        'Content-Type': 'application/json'
    }
})

const formatAuthorization = idToken => idToken + '.' + btoa(JSON.stringify({ 'id': 'FIELD_APP' }))

export default { 
    data: (idToken, params) => new Promise((resolve, reject) => {
        instance.post(
            '/field-app/data',
            params,
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
         .catch(error => {
            reject(error.response && error.response.data ? error.response.data : error)
        })
    })
}